import { useState, useEffect } from 'react';

export const useResponsive = () => {
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });
  
  const [breakpoints, setBreakpoints] = useState({
    isMobile: window.innerWidth <= 576,
    isTablet: window.innerWidth <= 768 && window.innerWidth > 576,
    isDesktop: window.innerWidth > 768,
    isPortrait: window.matchMedia('(orientation: portrait)').matches,
  });
  
  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      const height = window.innerHeight;
      
      setWindowSize({ width, height });
      setBreakpoints({
        isMobile: width <= 576,
        isTablet: width <= 768 && width > 576,
        isDesktop: width > 768,
        isPortrait: window.matchMedia('(orientation: portrait)').matches,
      });
    };
    
    window.addEventListener('resize', handleResize);
    window.addEventListener('orientationchange', handleResize);
    
    return () => {
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('orientationchange', handleResize);
    };
  }, []);
  
  return { ...windowSize, ...breakpoints };
};

export default useResponsive;